<template>
  <div>
    <div v-if="editProduto && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmitProduto" v-if="!editProduto || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!editProduto || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Situação" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                <el-option :key="false" label="INATIVO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Tipo" prop="tipo" :rules="[$requiredChange]" key="tipo">
              <el-select v-model="dados.tipo">
                <el-option label="CAPITAL" value="capital"></el-option>
                <el-option label="CUSTEIO" value="custeio"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Unidade de medida" prop="unidade_medida" key="unidade_medida">
              <el-input v-model="dados.unidade_medida" maxlength="191" v-on:blur="formatData('unidade_medida')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Categoria" prop="categoria" key="categoria">
              <el-input v-model="dados.categoria" maxlength="191" v-on:blur="formatData('categoria')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="191" v-on:blur="formatData('nome')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item label="Descrição" prop="descricao" key="descricao">
              <el-input type="textarea" :rows="4" v-model="dados.descricao"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-produto" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    editProduto: false,
    dados: {
      id: '',
      nome: '',
      descricao: '',
      categoria: '',
      unidade_medida: '',
      tipo: 'custeio',
      ativo: true,
    }
  }),
  methods: {
    getProdutoById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/produto/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => { this.dados = JSON.parse(JSON.stringify(response.data)) })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmitProduto () {
      document.getElementById("btn-produto").focus()

      this.$refs.dados.validate((valid) => {
        if (valid) {
          window.eventBus.$emit('loading', true)

          if (this.editProduto) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/produto/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitProduto')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          } else {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/produto/store`, this.dados, this.$store.getters.getHeaderAuth).then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.$emit('onSubmitProduto')
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
          }
        } else {
          window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        }
      })
    },
    formatData (field) {
      if (!this.dados[field]) return false
      this.dados[field] = this.dados[field].toUpperCase()
      this.dados[field] = this.$removerAcentos(this.dados[field])
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getProdutoById(value)
          this.editProduto = true
        }
      }
    }
  }
}
</script>

